import { render, staticRenderFns } from "./FiltroContas.vue?vue&type=template&id=0633c270&scoped=true"
import script from "./FiltroContas.vue?vue&type=script&lang=js"
export * from "./FiltroContas.vue?vue&type=script&lang=js"
import style0 from "./FiltroContas.vue?vue&type=style&index=0&id=0633c270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0633c270",
  null
  
)

export default component.exports